import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\t\tpadding: 0;\n\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t\t\tpadding: var(", ");\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\t\t\tpadding: 0;\n\t\t\t", "\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t\t\tpadding: ", ";\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t\t", "\n\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t", "\n\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { createStylesForBreakpoints, isBreakpointConfig } from '../helpers/breakpoint';
import { createCSSVarName } from '../theme-provider/create-css-var-name';
import { ContainerWrap } from './definitions';
var directions = ['top', 'right', 'bottom', 'left'];

function isDirectionalConfig(prop) {
  return typeof prop === 'object' && Object.keys(prop).every(function (key) {
    return directions.includes(key);
  });
} // create CSS variables for all dynamic sizes for a given configuration (e.g. container gutter or padding)


export function createCSSVariablesForSizes(configOrSize, theme) {
  if (!configOrSize) {
    return '';
  }

  if (isDirectionalConfig(configOrSize)) {
    return directions.map(function (key) {
      var directionalConfigOrSize = configOrSize[key];
      return createCSSVariablesForSizes(directionalConfigOrSize, theme);
    }).join('');
  }

  if (isBreakpointConfig(configOrSize)) {
    var cssVar = createCSSVarName(configOrSize, 'container');
    return createStylesForBreakpoints(configOrSize, function (size) {
      var value = theme.size[size];
      return "".concat(cssVar, ": ").concat(value, ";");
    });
  }

  return '';
}

function createSpacing(gutter, theme) {
  if (isBreakpointConfig(gutter)) {
    var cssVar = createCSSVarName(gutter, 'container');
    return "var(".concat(cssVar, ")");
  }

  return theme.size[gutter];
}

export function createHorizontalAlignmentStyles(horizontalAlign) {
  if (!isBreakpointConfig(horizontalAlign)) {
    return "justify-content: ".concat(horizontalAlign, ";");
  }

  return createStylesForBreakpoints(horizontalAlign, function (breakpointHorizontalAlign) {
    return "justify-content: ".concat(breakpointHorizontalAlign, ";");
  });
}

function wrapStyles(wrap, theme, gutter) {
  switch (wrap) {
    case ContainerWrap.never:
      return "\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t\tflex-direction: row;\n\t\t\t";

    case ContainerWrap.always:
      return "\n\t\t\t\tdisplay: block;\n\t\t\t\tflex-wrap: unset;\n\t\t\t\tflex-direction: unset;\n\t\t\t";

    default:
      {
        if (!gutter) {
          return "\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t";
        }

        var spacing = gutter && createSpacing(gutter, theme) || '0px';
        return "\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tmargin-right: calc(-1 * ".concat(spacing, ");\n\t\t\t\tmargin-bottom: calc(-1 * ").concat(spacing, ");\n\t\t\t");
      }
  }
}

export function createWrapStyles() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ContainerWrap.auto;
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var gutter = arguments.length > 2 ? arguments[2] : undefined;

  if (!isBreakpointConfig(wrap)) {
    var x = wrapStyles(wrap, theme, gutter);
    return x;
  }

  return css(_templateObject(), createStylesForBreakpoints(wrap, function (breakpointWrap) {
    return wrapStyles(breakpointWrap, theme, gutter);
  }));
}

function spacingBetweenElementsStyles(wrap, theme, gutter) {
  var spacing = gutter && createSpacing(gutter, theme) || '0px';

  switch (wrap) {
    case ContainerWrap.never:
      return "\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tmargin-right: ".concat(spacing, ";\n\t\t\t\t:last-child {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t");

    case ContainerWrap.always:
      return "\n\t\t\t\tmargin-bottom: ".concat(spacing, ";\n\t\t\t\tmargin-right: 0;\n\t\t\t\t:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t");

    default:
      return "\n\t\t\t\tmargin-right: ".concat(spacing, ";\n\t\t\t\tmargin-bottom: ").concat(spacing, ";\n\t\t\t\t/* we need to reset the margin-bottom for :last-child with at least the same specificity when it was already set in a breakpoint configuration before. */\n\t\t\t\t:last-child {\n\t\t\t\t\tmargin-bottom: ").concat(spacing, ";\n\t\t\t\t}\n\t\t\t");
  }
}

export function createSpacingBetweenElementsStyles() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ContainerWrap.auto;
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var gutter = arguments.length > 2 ? arguments[2] : undefined;

  if (!isBreakpointConfig(wrap)) {
    return spacingBetweenElementsStyles(wrap, theme, gutter);
  }

  return css(_templateObject2(), createStylesForBreakpoints(wrap, function (breakpointWrap) {
    return spacingBetweenElementsStyles(breakpointWrap, theme, gutter);
  }));
}
export function createSpacingAroundElementsStyles(padding, theme) {
  if (typeof padding === 'string' && theme) {
    return css(_templateObject3(), theme.size[padding]);
  }

  if (isDirectionalConfig(padding)) {
    return css(_templateObject4(), directions.reduce(function (acc, key) {
      var directionalPadding = padding[key];

      if (isBreakpointConfig(directionalPadding)) {
        var cssVar = createCSSVarName(directionalPadding, 'container');
        return "".concat(acc, "\n\t\t\t\t\t\tpadding-").concat(key, ": var(").concat(cssVar, ");");
      }

      if (typeof directionalPadding === 'string' && theme) {
        return "".concat(acc, "\n\t\t\t\t\t\tpadding-").concat(key, ": ").concat(theme.size[directionalPadding], ";");
      }

      return acc;
    }, ''));
  }

  if (isBreakpointConfig(padding)) {
    var cssVar = createCSSVarName(padding, 'container');
    return css(_templateObject5(), cssVar);
  }

  return css(_templateObject6());
}